import { render, staticRenderFns } from "./CadastroTempoEsperaCor.vue?vue&type=template&id=367b490c&"
import script from "./CadastroTempoEsperaCor.vue?vue&type=script&lang=js&"
export * from "./CadastroTempoEsperaCor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports